// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyButton_butn_box__3miQ- {
    width: 160px;
    height: 50px;
}

.MyButton_butn__naRwB {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 50px;
    border-radius: 6px;
    letter-spacing: 2px;
    cursor: pointer;
    color: #fff;
    box-sizing: border-box;
    border-radius: 6px;
    position: relative;
    -webkit-user-select: none;
            user-select: none;
}

.MyButton_butn__naRwB:hover {
}

.MyButton_butn__naRwB:active {
    top: 3px;
    height: calc(100% - 3px) !important;
}

.MyButton_primary__7R3sd {
    color: #fff;
    background-color: #17a8b5;
    border-bottom: 3px solid #12828c;
}

.MyButton_primary__7R3sd:hover {
    background-color: #00bbcc;
}

.MyButton_primary__7R3sd:active {
    background-color: #17a8b5;
    border-bottom-width: 0px;
}

.MyButton_light__9PgR0 {
    color: #17A8B5;
    background-color: #ffffff;
    border: 1px solid #12828c;
    border-bottom-width: 4px;
}

.MyButton_light__9PgR0:hover {
    background-color: #e4f0f2;
}

.MyButton_light__9PgR0:active {
    background-color: #ffffff;
    border-bottom-width: 1px;
}

.MyButton_default__yzuLA {
    color: #A6A6A6;
    background-color: #ffffff;
    border: 1px solid #e1e1e1;
    border-bottom-width: 4px;
}

.MyButton_default__yzuLA:hover {
    background-color: #eeeeee;
}

.MyButton_default__yzuLA:active {
    background-color: #ffffff;
    border-bottom-width: 1px;
}`, "",{"version":3,"sources":["webpack://./src/common/MyButton/index.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;AACA;;AAEA;IACI,QAAQ;IACR,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;AAC5B","sourcesContent":[".butn_box {\n    width: 160px;\n    height: 50px;\n}\n\n.butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 160px;\n    height: 50px;\n    border-radius: 6px;\n    letter-spacing: 2px;\n    cursor: pointer;\n    color: #fff;\n    box-sizing: border-box;\n    border-radius: 6px;\n    position: relative;\n    user-select: none;\n}\n\n.butn:hover {\n}\n\n.butn:active {\n    top: 3px;\n    height: calc(100% - 3px) !important;\n}\n\n.primary {\n    color: #fff;\n    background-color: #17a8b5;\n    border-bottom: 3px solid #12828c;\n}\n\n.primary:hover {\n    background-color: #00bbcc;\n}\n\n.primary:active {\n    background-color: #17a8b5;\n    border-bottom-width: 0px;\n}\n\n.light {\n    color: #17A8B5;\n    background-color: #ffffff;\n    border: 1px solid #12828c;\n    border-bottom-width: 4px;\n}\n\n.light:hover {\n    background-color: #e4f0f2;\n}\n\n.light:active {\n    background-color: #ffffff;\n    border-bottom-width: 1px;\n}\n\n.default {\n    color: #A6A6A6;\n    background-color: #ffffff;\n    border: 1px solid #e1e1e1;\n    border-bottom-width: 4px;\n}\n\n.default:hover {\n    background-color: #eeeeee;\n}\n\n.default:active {\n    background-color: #ffffff;\n    border-bottom-width: 1px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"butn_box": `MyButton_butn_box__3miQ-`,
	"butn": `MyButton_butn__naRwB`,
	"primary": `MyButton_primary__7R3sd`,
	"light": `MyButton_light__9PgR0`,
	"default": `MyButton_default__yzuLA`
};
export default ___CSS_LOADER_EXPORT___;
